<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add New Batch Clients</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
               <vs-input
              name="description"
              class="w-full"
              v-model="batch_clients.name"
              v-validate="'required'"
                data-vv-as="Name"
            />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('name')"
              >{{ errors.first("name") }}</span
            >
          </div>
      
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Description:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
               <vs-input
              name="description"
              class="w-full"
              v-model="batch_clients.description"
              v-validate="'required'"
                data-vv-as="Description"
            />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('description')"
              >{{ errors.first("description") }}</span
            >
          </div>
                    <div class="vx-row mb-6">

          <div class="vx-col sm:w-1/5 w-full">
              <span>Clients:</span>
                        </div>
<div class="vx-col sm:w-1/2 w-full">

            

          <vs-row vs-w="12">
            <vs-col v-for="(client) in client_lists" class="mb-10"
              vs-lg="4"
              vs-sm="4"
              vs-xs="12"
            >

             <vs-checkbox
                  name="batch_clients_step"
                v-model="batch_clients.selected_clients"
                  :vs-value="client.uuid"
                  >{{ client.company_name }}</vs-checkbox
                >
             
            </vs-col>
       
          </vs-row>


              
              </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
          <vs-divider class="m-5" />

          <!-- <DataGrid :context="'Batch Clients'" 
            ref="batch_clients"
            :columnDefs="columnDefs"
            :rowData="records"
            :dataSource="dataSource"
          >
          </DataGrid> -->
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleBatchClientsManagement from "@/store/batch_clients-management/moduleBatchClientsManagement.js";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import vSelect from "vue-select";
export default {
  beforeMount() {
    this.getDataSource();
  },
  data() {
    return {
      campaign_required: null,
      companySearchComponentKey: 0,
      columnDefs: [
         {
          headerName: "Campaign",
          flex: 1,
          field: "campaign_name",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "BatchClients",
          flex: 1,
          field: "batch_clients",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          headerName: "Description",
          flex: 1,
          field: "description",
          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        },
        {
          flex: 1,

          headerName: "BatchClients Steps",
          field: "batch_clients_step_name",

          filter: "agTextColumnFilter",
          filterParams: {
            buttons: ["apply", "reset"],
            maxNumConditions: 4
          }
        }
      ],
      dataSource: {},
      records: [],
      selected: [],
      abilities: null,
      batch_clients: {
        name: null,
        description:null,
        selected_clients: [],
      },
      client_lists:[]
    };
  },
  components: {
    "v-select": vSelect,
    moduleBatchClientsManagement,
    DataGrid,
    CampaignAutocomplete
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleBatchClientsManagement.isRegistered) {
      this.$store.registerModule("BatchClientsManagement", moduleBatchClientsManagement);
      moduleBatchClientsManagement.isRegistered = true;
    }

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
  },
  mounted() {
          this.getAllClients()

  },
  watch: {},
  methods: {
    getAllClients() {
      let self = this;
      self.$store
        .dispatch(
          "campaignsManagement/fetchAllClients"
        )
        .then(response => {
          let response_data = response.data;
          if (response_data) {
            self.client_lists = JSON.parse(response_data);
          }
          console.log("All client_lists Step", self.client_lists);

        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
  
   
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          self.$store
            .dispatch("BatchClientsManagement/getAllBatchClientss", params.request)
            .then(function(response) {
              let response_data = response.rows;
              if (response_data.length != 0) {
                self.$refs.batch_clients.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.batch_clients.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function() {
      this.$router.go(-1);
    },
    submitForm() {
   

      this.$validator.validateAll().then(result => {
        if (result) {
          this.addBatchClients();
        }
      });
    },
    addBatchClients() {

      if (this.batch_clients.selected_clients.length === 0) {
        this.$vs.notify({
          color: "warning",
          title: "No Clients Selected",
          text: "Please select at least one client."
        });
        return;
      }

      this.$store
        .dispatch("BatchClientsManagement/addBatchClients", this.batch_clients)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "Batch Clients Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Batch Clients Added",
              text: "The batch_clients was added successfully"
            });
            this.$router.go(0);
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  }
};
</script>
<style scoped>
.removeButton {
  cursor: pointer;
}
.removeButtonClass {
  cursor: pointer;
  position: relative;
  float: right;
  margin-top: -25px;
  margin-right: 25px;
}
</style>
